import { SiteLink as Link } from './SiteLink';
import { SIGNUP_URL } from '../lib/appUrls';

/** The shared close on interior pages. The landing page ends on its painting instead. */
export function GetStarted() {
  return (
    <section className="s-wrap" aria-labelledby="get-started-title">
      <div className="l-close">
        <div>
          <h2 id="get-started-title">Lock down your first tool in minutes.</h2>
          <p>
            Three MCP servers, one of them hosted, and 10,000 calls a month, free and without a card. If you outgrow it
            the next plan is $19.
          </p>
          <p className="l-close-how">
            Two steps: create your account, then install the desktop app on each machine that runs an AI client.
          </p>
          <ul>
            <li>Keys encrypted at rest, never handed to an agent</li>
            <li>Cancel anytime, nothing is deleted</li>
            <li>
              <Link className="s-link" to="/security">
                How Statio handles credentials
              </Link>
            </li>
          </ul>
        </div>
        <div className="l-close-ctas">
          <a className="s-btn s-btn-pri" href={SIGNUP_URL} target="_blank" rel="noopener noreferrer">
            Start free
          </a>
          <Link className="s-btn s-btn-sec" to="/download">
            Download the app
          </Link>
        </div>
      </div>
    </section>
  );
}
